import core from "./core";

const advancementChart = [
  { level: 1, experience: 0, next: 1000 },
  { level: 2, experience: 1000, next: 2000 },
  { level: 3, experience: 2000, next: 3000 },
  { level: 4, experience: 3000, next: 4000 },
  { level: 5, experience: 4000, next: 5000 },
  { level: 6, experience: 5000, next: 6000 },
  { level: 7, experience: 6000, next: 7000 },
  { level: 8, experience: 7000, next: 8000 },
  { level: 9, experience: 8000, next: 9000 },
  { level: 10, experience: 9000, next: 10000 },
  { level: 11, experience: 10000, next: 11000 },
  { level: 12, experience: 11000, next: 12000 },
  { level: 13, experience: 12000, next: 13000 },
  { level: 14, experience: 13000, next: 14000 },
  { level: 15, experience: 14000, next: 15000 },
  { level: 16, experience: 15000, next: 16000 },
  { level: 17, experience: 16000, next: 17000 },
  { level: 18, experience: 17000, next: 18000 },
  { level: 19, experience: 18000, next: 19000 },
  { level: 20, experience: 19000, next: 20000 }
];

const getAdvancement = experience => {
  let advancement;
  advancement = advancementChart.find(
    x => x.experience <= experience && x.next > experience
  );
  advancement = advancement || advancementChart[0];
  return advancement;
};

const getLevel = experience => {
  let advancement = getAdvancement(experience);
  let level = advancement ? advancement.level : 0;
  return level;
};

const getProficiencyBonus = (experience, item, attribute) => {
  let level = getLevel(experience);
  let attBonus = attribute ? core.getAttributeBonus(attribute) : 0;

  let miscBonus =
    item.misc && isFinite(item.misc) ? parseInt(item.misc, 10) : 0;
  let magicBonus =
    item.magic && isFinite(item.magic) ? parseInt(item.magic, 10) : 0;

  let temlBonus = 0;
  switch (item.proficiency) {
    case 1:
      temlBonus = 2;
      break;
    case 2:
      temlBonus = 4;
      break;
    case 3:
      temlBonus = 6;
      break;
    case 4:
      temlBonus = 8;
      break;
  }

  let baseBonus = attBonus + temlBonus + miscBonus + magicBonus;

  baseBonus = temlBonus == 0 ? baseBonus : baseBonus + level;

  return baseBonus;
};

const getDescriptor = entity => {
  let ancestry = entity.ancestry || "";
  let klass = entity.class
    ? `${entity.class} ${getLevel(entity.experience)}`.trim()
    : "";

  let description =
    entity.ancestry || klass ? `${ancestry} ${klass}`.trim() : "Peasant";
  return description;
};

const health = payload => {
  payload = payload || {};

  if (payload.dead) {
    return "dead";
  }

  if (payload.dying > 3) {
    return "dead";
  }

  if (payload.hitPoints) {
    if (payload.hitPoints.current < 1) {
      return "unconcious";
    }

    if (
      payload.hitPoints.current > parseInt(payload.hitPoints.maximum, 10) / 2 &&
      payload.hitPoints.current < payload.hitPoints.maximum
    ) {
      return "hurt";
    }
  }

  return "full";
};

const isDead = entity => {
  let constitution = core.getAttributeBonus("constitution");

  let payload = {
    dead: entity.dead || false,
    hitPoints: {
      current: core.getTotalHitPoints(entity.hitPoints),
      maximum: entity.hitPoints.maximum
    },
    constitution: constitution.score
  };

  if (entity.dying) {
    payload.dying = entity.dying.current;
  }
  let status = health(payload);
  return status === "dead";
};

const getArmorClassDex = ac => {
  let armorClass = ac.armorClass;
  let dexterity = ac.dexterity;
  let base = core.getAttributeBonus(dexterity);

  if (armorClass.armor) {
    if (
      Number.isFinite(armorClass.armor.maxDex) &&
      base > armorClass.armor.maxDex
    )
      base = armorClass.armor.maxDex;
  }

  if (
    armorClass.shield &&
    Number.isFinite(armorClass.shield.maxDex) &&
    base > armorClass.shield.maxDex
  ) {
    base = armorClass.shield.maxDex;
  }

  return base;
};

const getArmorClass = ac => {
  let experience = ac.experience;
  let armorClass = ac.armorClass;
  let base = 10 + getProficiencyBonus(experience, armorClass.armor);

  let total = base + getArmorClassDex(ac);
  if (armorClass.armor && Number.isFinite(armorClass.armor.bonus))
    total += armorClass.armor.bonus;
  if (
    armorClass.shield &&
    Number.isFinite(armorClass.shield.bonus) &&
    armorClass.shield.raised !== false
  )
    total += armorClass.shield.bonus;

  return total;
};

const getArmorClassTouch = ac => {
  let experience = ac.experience;
  let armorClass = ac.armorClass;
  let base = 10 + getProficiencyBonus(experience, armorClass.armor);

  let total = base + getArmorClassDex(ac);
  if (armorClass.armor && Number.isFinite(armorClass.armor.touchBonus))
    total += armorClass.armor.touchBonus;
  if (
    armorClass.shield &&
    Number.isFinite(armorClass.shield.touchBonus) &&
    armorClass.shield.raised !== false
  )
    total += armorClass.shield.touchBonus;
  return total;
};

const getAttackBonus = payload => {
  let experience = payload.experience;
  let attack = payload.item.attack;
  let attribute = payload.attribute;

  let bonus = attack ? getProficiencyBonus(experience, attack, attribute) : 0;

  return bonus;
};

const getDamageBonus = payload => {
  let damage = payload.damage;
  let attribute = payload.attribute;

  if (damage) {
    let bonus = 0;
    bonus += attribute ? core.getAttributeBonus(attribute) : 0;

    bonus +=
      damage.misc && isFinite(damage.misc) ? parseInt(damage.misc, 10) : 0;

    bonus +=
      damage.magic && isFinite(damage.magic) ? parseInt(damage.magic, 10) : 0;

    return bonus;
  }

  return;
};

const getCarriedWeight = items => {
  let itemWeights = [];
  items.filter(x => x.carried).forEach(item => {
    let quantity = item.quantity && isFinite(item.quantity) ? item.quantity : 0;
    let weight = item.quantity && isFinite(item.weight) ? item.weight : 0;
    if (quantity > 0 && weight > 0) itemWeights.push(quantity * weight);
  });
  var totalWeight = itemWeights.reduce((prevVal, val) => {
    return parseFloat(prevVal) + parseFloat(val);
  }, 0);

  let fixedFloat = Math.floor(totalWeight.toFixed(1));

  return fixedFloat;
};

const getSpellBonus = (experience, item, attribute) => {
  return getProficiencyBonus(experience, item, attribute);
};

const getBulk = v => {
  if (v < 0.1) return "-";
  return v === 0.1 ? "L" : v;
};

const getBulkOptions = () => {
  let options = [
    {
      id: 0.1,
      text: "L"
    }
  ];
  for (let i = 0; i < 20; i++) {
    options.push({ id: i + 1, text: i + 1 });
  }
  return options;
};

const getActionTypes = () => {
  let actionTypes = core.actionTypes;
  return actionTypes;
};

const getItemTypes = () => {
  let itemTypes = core.itemTypes;
  return itemTypes;
};

const ruleset = {
  getLevel: getLevel,
  getProficiencyBonus: getProficiencyBonus,
  getDescriptor: getDescriptor,
  getArmorClass: getArmorClass,
  getArmorClassDex: getArmorClassDex,
  getArmorClassTouch: getArmorClassTouch,
  getAttackBonus: getAttackBonus,
  getDamageBonus: getDamageBonus,
  getCarriedWeight: getCarriedWeight,
  getSpellBonus: getSpellBonus,
  getBulk: getBulk,
  getBulkOptions: getBulkOptions,

  getActionTypes: getActionTypes,
  getItemTypes: getItemTypes,

  getAttribute: core.getAttribute,
  getAttributeBonus: core.getAttributeBonus,
  getTotalHitPoints: core.getTotalHitPoints,
  attributeOptions: core.attributeOptions,
  spellSchools: core.spellSchools,

  ruleTypes: core.ruleTypes,
  ruleTypesPlural: core.ruleTypesPlural,

  health: health,
  isDead: isDead
};

export default ruleset;
